const BrowsingLinks = [
  { id: 1, title: "home", path: "/" },
  { id: 3, title: "services", path: "/services" },
  { id: 2, title: "pricing", path: "/pricing" },
  { id: 4, title: "rooms", path: "/rooms" },
  { id: 5, title: "contact", path: "/contact" },
];

export default BrowsingLinks;
